import { useEffect, useState } from "react";

interface ToolbarInfos {
	toolbarVisible: boolean;
	toolbarPosition: {
		x: number;
		y: number;
	};
}

export function useToolbarInfos(ref: React.RefObject<HTMLDivElement | null>): ToolbarInfos {
	const [toolbarVisible, setToolbarVisible] = useState(false);
	const [toolbarPosition, setToolbarPosition] = useState({ x: 0, y: 0 });

	useEffect(() => {
		const updateVisibility = (): void => {
			const selection = window.getSelection();
			const rect = selection && selection.rangeCount > 0 ? selection.getRangeAt(0).getBoundingClientRect() : undefined;
			const parentRect = ref.current?.getBoundingClientRect();
			const content = selection?.toString();
			const isVisible = !!rect && !!parentRect && !!content && isInside(rect, parentRect);

			if (isVisible && !!rect && !!parentRect) {
				setToolbarPosition(getToolbarPosition(rect, parentRect));
			}
			setToolbarVisible(isVisible);
		};

		document.addEventListener("selectionchange", updateVisibility);
		return () => document.removeEventListener("selectionchange", updateVisibility);
	}, []);

	return { toolbarVisible, toolbarPosition };
}

function isInside(rect: DOMRect, parentRect: DOMRect): boolean {
	return (
		rect.top >= parentRect.top &&
		rect.top + rect.height <= parentRect.top + parentRect.height &&
		rect.left >= parentRect.left &&
		rect.left + rect.width <= parentRect.left + parentRect.width
	);
}

function getToolbarPosition(selection: DOMRect, parent: DOMRect): { x: number; y: number } {
	const x = selection.left - parent.left + selection.width / 2;
	const y = selection.top - parent.top;

	return { x, y };
}
